/**
 * SegmentedTabs - Apple-style pill tab header renderer.
 * Renders into a host element and wires click handlers.
 */

export function renderSegmentedTabs(host, tabs, activeId, onSelect) {
  if (!host) return;
  // Render header
  host.innerHTML = `
    <div class="tab-header">
      ${tabs.map(t => `
        <button class="tab-btn ${t.id === activeId ? 'active' : ''}" data-tab="${t.id}">
          <span class="tab-label">${t.label}</span>
        </button>
      `).join('')}
    </div>`;

  const header = host.firstElementChild;
  if (!header) return;
  // Sliding indicator
  const indicator = document.createElement('div');
  indicator.className = 'tab-indicator';
  header.appendChild(indicator);

  const positionIndicator = () => {
    const active = header.querySelector('.tab-btn.active') || header.querySelector('.tab-btn');
    if (!active) return;
    const left = active.offsetLeft;
    const width = active.offsetWidth;
    indicator.style.width = `${width}px`;
    indicator.style.transform = `translate(${left}px, -50%)`;
  };

  // Wire clicks
  header.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const id = e.currentTarget.dataset.tab;
      if (typeof onSelect === 'function') onSelect(id);
    });
  });

  // Resize handling (debounced by RAF)
  if (header.__onResize) window.removeEventListener('resize', header.__onResize);
  header.__onResize = () => requestAnimationFrame(positionIndicator);
  window.addEventListener('resize', header.__onResize);

  // Initial position
  positionIndicator();
}

export default { renderSegmentedTabs };
